app.directive('hoeveelKanIkLenen', ['bezoeker', 'globals', '$http', '$window', '$timeout', function(bezoeker, globals, $http, $window, $timeout){
	return {
		restrict: 'EAC',
		scope: {},
		templateUrl: '/templates/hoeveel-kan-ik-lenen.html',
		link: function($scope, $element) {

			$scope.bezoeker = bezoeker;

			$scope.onSubmit = function(e) {
				e.preventDefault();

				$scope.bezoeker.leencapaciteit = berekenMaxLeenbedrag();
				$scope.bezoeker.gewenstLeenbedrag = $scope.bezoeker.leencapaciteit;

				form = $element.find('form#hoeveel-kan-ik-lenen-tool');

				$scope.hoeveelKanIkLenen.dirtyCheck.$setViewValue($scope.hoeveelKanIkLenen.dirtyCheck.$viewValue);

				if($scope.hoeveelKanIkLenen.$valid)
				{
					$http.post('/session/setLeencapaciteit/', {'leencapaciteit' : $scope.bezoeker.leencapaciteit}).success(function(data, status, headers, config) {
						$http.post('/session/saveUser/', $scope.bezoeker).success(function(){
							angular.element('#hoeveel-kan-ik-lenen-tool').submit();
						});;
					});

				}else{
					form.find('.ng-invalid:first').focus();
				}
			};

			function berekenMaxLeenbedrag()
			{
				var nettoInkomen = $scope.bezoeker.nettoMaandinkomen;
				var nettoInkomenPartner = $scope.bezoeker.nettoMaandinkomenPartner;
				var inkomsten = $scope.bezoeker.nettoMaandinkomen + $scope.bezoeker.nettoMaandinkomenPartner;
				var woonlasten = $scope.bezoeker.brutoWoonlastenPerMaand;
				var norm = 0;
				var basishuur = 0;
				var maximalisatie = 0;
				var vasteKosten = 0;
				var heffingskorting = 124;

				if($scope.bezoeker.woonsituatie == 'koop'){
					if(inkomsten > 3446)
					{
						woonlasten = 0.70 * $scope.bezoeker.brutoWoonlastenPerMaand;
					}else{
						woonlasten = 0.75 * $scope.bezoeker.brutoWoonlastenPerMaand;
					}
				}

				if($scope.bezoeker.woonsituatie == 'thuiswonend')
				{
					if(inkomsten * 0.35 < 350)
					{
						woonlasten = 350;
					}else if(inkomsten * 0.35 > $scope.bezoeker.brutoWoonlastenPerMaand)
					{
						woonlasten = inkomsten *0.35;
					}else{
						woonlasten = $scope.bezoeker.brutoWoonlastenPerMaand;
					}
				}

				if($scope.bezoeker.leefsituatie == '1')
				{
					nettoInkomenPartner = 0;
					$scope.bezoeker.nettoMaandinkomenPartner = 0;
					inkomsten = $scope.bezoeker.nettoMaandinkomen;
					if($scope.bezoeker.kinderen === 'ja'){
						norm = 990;
						basishuur = 230;
						maximalisatie = 2877;
						vasteKosten = 1243;
					}else{
						norm = 815;
						basishuur = 230;
						maximalisatie = 3035;
						vasteKosten = 1118;
					}
				}
				else
				{
					if(nettoInkomenPartner === 0)
					{
						nettoInkomen = (nettoInkomen + heffingskorting);
						inkomsten = (inkomsten + heffingskorting);
					}

					if($scope.bezoeker.kinderen === 'ja'){
						norm = 1332;
						basishuur = 230;
						maximalisatie = 2877;
						vasteKosten = 1534;
					}else{
						norm = 1276;
						basishuur = 230;
						maximalisatie = 3035;
						vasteKosten = 1510;
					}
				}

				var levensonderhoud = (0.15 * ((nettoInkomen + nettoInkomenPartner) - basishuur - norm)) + norm;

				if(inkomsten > maximalisatie)
				{
					levensonderhoud = vasteKosten;
				}

				var termijnbedrag = inkomsten - woonlasten - levensonderhoud;

				var leencapaciteit = Math.ceil(termijnbedrag * 50);

				if(leencapaciteit < 0) leencapaciteit = 0;

				if(leencapaciteit > 25000) leencapaciteit = Math.ceil(termijnbedrag * 65);

				return leencapaciteit;
			}

			/* Na het opnieuw inladen van de rentetarieven moet de styling op de selectbox opnieuw geinitieerd worden. */
			function rebuildSelect2()
			{
				$window.setTimeout(function() {
					$(".hkil select.js-select").select2({
						minimumResultsForSearch: -1,
						width: '100%',
						theme: 'pwc',
						dropdownAutoWidth: 'true'
					});
				}, 10 );
			}

			rebuildSelect2();
		}
	};
}]);